import type {
  GeneratedTheme,
  ListItemComponentTheme,
  Theme,
} from '../../types';

type Props = {
  core: Theme['core'];
  semantic: Theme['semantic'];
  components: GeneratedTheme['components'];
};

const mapListItemTheme = ({
  core,
  components,
}: Props): ListItemComponentTheme => {
  const { ListItem } = components;

  const variant = ListItem.regular;

  return {
    ...variant,
    'font-size': core.typography.fontSize.base,
    'icon-size': core.iconSize.m,
    'border-size': core.spacing['2x'],
  };
};

export default mapListItemTheme;
